import styled, { keyframes } from 'styled-components'
import Colors from '../../../../themes/Colors'

// A moving highlight sweeping across a flat gray base. Compose skeletons by
// placing SkeletonBlock elements inside the real card Holders (so the loading
// placeholder matches the real layout exactly); set each block's size via inline
// `style={{ width, height }}` at the call site.
const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`

const SkeletonBlock = styled.span`
  display: inline-block;
  border-radius: 4px;
  background-color: ${Colors.gray};
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${shimmer} 1.4s ease infinite;
`

export default SkeletonBlock
